// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homeHeaderSection{
    padding-top: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.homeHeaderSection .titleContent{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    text-align: center;
}

.homeHeaderSection .titleContent p{
    white-space: pre-line;
    padding-top: 20px;
}

.homeHeaderSection img{
    margin-top: 30px;
    max-width: 100%;
}

.homeHeaderSection .buttonsContent{
    width: 100%;
    margin-right: 400px;
    margin-bottom: 100px;
    display: flex;
    align-items: center;
    justify-content: end;
    flex-direction: row;
}

.homeHeaderSection .buttonsContent button{
    background: transparent;
    color: white;
    padding: 10px;
    margin-right: 20px;
    border: none;
    cursor: pointer;
}

.homeHeaderSection .buttonsContent .download{
    background: white;
    color: black;
    font-weight: bold;
    padding: 10px 15px;
    margin-right: 30px;
    border-radius: 15px;
}

@media (max-width: 767px) {
    .homeHeaderSection{
        padding-top: 100px;
    }

    .homeHeaderSection .buttonsContent{
        width: 100%;
        margin-right: 0;
        margin-bottom: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home/section/HeaderSection/styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;IACvB;AACJ","sourcesContent":[".homeHeaderSection{\n    padding-top: 150px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.homeHeaderSection .titleContent{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    text-align: center;\n}\n\n.homeHeaderSection .titleContent p{\n    white-space: pre-line;\n    padding-top: 20px;\n}\n\n.homeHeaderSection img{\n    margin-top: 30px;\n    max-width: 100%;\n}\n\n.homeHeaderSection .buttonsContent{\n    width: 100%;\n    margin-right: 400px;\n    margin-bottom: 100px;\n    display: flex;\n    align-items: center;\n    justify-content: end;\n    flex-direction: row;\n}\n\n.homeHeaderSection .buttonsContent button{\n    background: transparent;\n    color: white;\n    padding: 10px;\n    margin-right: 20px;\n    border: none;\n    cursor: pointer;\n}\n\n.homeHeaderSection .buttonsContent .download{\n    background: white;\n    color: black;\n    font-weight: bold;\n    padding: 10px 15px;\n    margin-right: 30px;\n    border-radius: 15px;\n}\n\n@media (max-width: 767px) {\n    .homeHeaderSection{\n        padding-top: 100px;\n    }\n\n    .homeHeaderSection .buttonsContent{\n        width: 100%;\n        margin-right: 0;\n        margin-bottom: 50px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: row;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
